module.exports = __webpack_public_path__ + "9c5f394190ac56424d0ed9877527bbc6.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/logo.svg
// module id = 31
// module chunks = 0